import CryptoJS, {SHA256, enc} from 'crypto-js'

/**
 * Every value must be in lower case and the spaces must be replaced by underscores.
 * E.g.: Foo Bar -> foo_bar
 * Don’t include special characters (like quote) in the value:
 * cucinelli_what&#x27;s_hot_archive → wrong value
 * cucinelli_whats_hot → right value
 **/
function formattingString(str: string): string {
    if (!str) return ''
    const newString = str
        .toLowerCase()
        .replace(/-/g, '_')
        .replace(/\s/g, '_')
        .replace(/[^a-z0-9_/]/g, '')
    return newString
}

// NUMBERS FORMATTING
// All the numbers must avoid thousands separator. The decimal separator must be “.”
// Do not include any currency code in the prices.
// Es: € 1.300,50 -> 1300.50
function formattingNumbers(number: number | string): number {
    const parsedNumber = typeof number === 'number' ? number : parseFloat(number)
    if (!isNaN(parsedNumber)) {
        return Math.round(parsedNumber * 100) / 100
    }
    return 0
}

/**
 * Converts a date string from the format "YYYY-MM-DD" to "MM_DD_YYYY".
 *
 * @param dateString - The date string to be converted.
 * @returns The formatted date string.
 */
function convertDateFormat(dateString: string) {
    const [year, month, day] = dateString.split('-')
    const formattedDate = `${month}_${day}_${year}`
    return formattedDate
}

function hashValueBase64(value: string): string {
    const hash: CryptoJS.lib.WordArray = SHA256(value)
    return hash.toString(enc.Base64)
}

function hashValueHex(value: string): string {
    const hash: CryptoJS.lib.WordArray = SHA256(value)
    return hash.toString(enc.Hex)
}

export {formattingString, formattingNumbers, convertDateFormat, hashValueBase64, hashValueHex}
